import Api from './Api';

class _ActorApi extends Api {
    loadActors(filter = {}, projectId: number = null): Promise<any> {
        return this.getHttpClient().get(`actor/list`, { params: { ...filter, projectId } });
    }

    loadActor(id: number): Promise<any> {
        return this.getHttpClient().get(`actor/detail/${id}`);
    }

    saveActor(params: any): Promise<any> {
        return this.getHttpClient().post(`actor/detail`, params);
    }

    updateVoice(params: FormData): Promise<any> {
        return this.getHttpClient().post(`actor/voice`, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    savePrice(data: any) {
        console.log(data);
        return this.getHttpClient().post(`actor/prices`, data);
    }
}

export const ActorApi = new _ActorApi();
